module.exports = __webpack_public_path__ + "media/images/lb/891-d02965775c0a811f2326f7145eaf5433.svg";